{
  "debugLogin": {
    "number": "Dev user #",
    "signIn": "Dev sign in",
    "signingIn": "Signing in…",
    "failed": "Dev sign-in failed (HTTP {{status}}). Check that the API uses ENV=dev.",
    "networkError": "Could not reach the local API."
  },
  "common": {
    "retry": "Retry",
    "loadFailed": "Couldn't load this. Try again.",
    "loading": "Loading…",
    "close": "Close",
    "dismiss": "Dismiss",
    "you": "you",
    "youCap": "You",
    "cancel": "Cancel",
    "showPassword": "Show password",
    "hidePassword": "Hide password"
  },
  "nav": {
    "main": "Main",
    "skip": "Skip to content",
    "games": "Games",
    "packages": "Packages",
    "profile": "Profile and settings",
    "signIn": "Sign in",
    "admin": "Admin",
    "leaderboard": "Leaderboard"
  },
  "notFound": {
    "title": "This page doesn't exist"
  },
  "roles": {
    "showman": "Showman",
    "player": "Player",
    "spectator": "Spectator"
  },
  "login": {
    "title": "Pick a name and play",
    "subtitle": "No account needed. Your name is what other players see.",
    "nameLabel": "Your name",
    "namePlaceholder": "e.g. Mira",
    "nameHelp": "1–50 characters. You can change it later in settings.",
    "nameRequired": "Type a name first.",
    "continueGuest": "Continue as guest",
    "signingIn": "Signing in…",
    "discordHelp": "Have Discord? Sign in to keep your packages and name on every device.",
    "discord": "Sign in with Discord",
    "discordFailed": "Discord sign-in didn't finish. Try again or continue as a guest."
  },
  "home": {
    "inProgress": "Game in progress",
    "stillIn": "You're still in “{{title}}”",
    "stillInLobby": "The lobby is waiting. Your seat is kept.",
    "stillInPlaying": "The game is running. Your seat and score are kept.",
    "rejoin": "Rejoin",
    "joinTitle": "Join a game in seconds",
    "joinSubtitle": "Paste an invite link or room code. You'll land in the lobby with a seat waiting.",
    "codeLabel": "Room code or invite link",
    "codeInvalid": "That doesn't look like a room code or game link.",
    "join": "Join",
    "watch": "Spectate",
    "hostTitle": "Host your own",
    "hostSubtitle": "Pick a package, set the room, share the link. You're the showman.",
    "createGame": "Create game",
    "openGames": "Open games",
    "search": "Search games",
    "clearSearch": "Clear search",
    "noMatches": "No games match your search and filters.",
    "filter": "Filter games",
    "filters": {
      "all": "All",
      "lobby": "In lobby",
      "playing": "In progress"
    },
    "status": {
      "lobby": "In lobby",
      "playing": "In progress"
    },
    "private": "Password",
    "package": "Package · {{title}}",
    "players": "players",
    "host": "Host {{name}}",
    "noGames": "No open games right now. Host one and share the link!",
    "loadFailed": "Couldn't load games. Check your connection and try again.",
    "hideRejoin": "Hide",
    "notice": {
      "kicked": "You were removed from the game.",
      "deleted": "The showman deleted the game.",
      "closed": "A moderator closed the game."
    }
  },
  "packages": {
    "title": "Packages",
    "search": "Search by title",
    "language": "Language",
    "anyLanguage": "Any",
    "sort": "Sort",
    "sortNewest": "Newest",
    "sortTitle": "Title A–Z",
    "by": "by {{name}}",
    "counts": "{{rounds}} rounds · {{questions}} questions",
    "empty": "No packages match. Try another search.",
    "loadFailed": "Couldn't load packages.",
    "details": "Package details",
    "pickOne": "Pick a package to see its rounds and host a game with it.",
    "rounds": "Rounds",
    "roundCounts": "{{themes}} themes · {{questions}} q",
    "finalThemes": "{{count}} final themes",
    "has": "Has {{list}}",
    "special": "{{list}} questions",
    "media": {
      "images": "images",
      "audio": "audio",
      "video": "video"
    },
    "host": "Host a game with this",
    "signInToHost": "Sign in to host",
    "prev": "Previous",
    "next": "Next",
    "page": "Page {{page}} of {{pages}}",
    "upload": "Upload package",
    "create": "Create package",
    "sortOldest": "Oldest",
    "sortTitleDesc": "Title Z–A",
    "sortAuthor": "Author",
    "moreFilters": "More filters",
    "hideFilters": "Fewer filters",
    "age": "Age rating",
    "anyAge": "Any",
    "ageNone": "For everyone",
    "roundsRange": "Rounds",
    "questionsRange": "Questions",
    "min": "Min",
    "max": "Max",
    "onlyMine": "Only my packages",
    "clearFilters": "Clear filters",
    "preview": "Preview questions",
    "uploadUnfinished": "Upload not finished",
    "uploadUnfinishedHelp": "Some of this package's media is still being uploaded by its author, so a game can't be started with it yet.",
    "uploadUnfinishedAuthor": "Some media files haven't been uploaded, so nobody can start a game with this package yet. Finish the upload to make it playable.",
    "resumeUpload": "Finish upload"
  },
  "questionTypes": {
    "simple": "Simple",
    "stake": "Stake",
    "secret": "Secret",
    "noRisk": "No risk",
    "hidden": "Hidden",
    "choice": "Choice"
  },
  "create": {
    "back": "Back to packages",
    "title": "Create a game",
    "name": "Game name",
    "defaultTitle": "{{name}}'s game",
    "players": "Players",
    "upTo": "Up to {{count}}",
    "age": "Age rating",
    "ageNone": "Everyone",
    "whoCanJoin": "Who can join",
    "public": "Anyone with the link",
    "private": "Password",
    "password": "Password",
    "passwordPlaceholder": "Leave empty to generate one",
    "passwordHelp": "Letters, digits, - and _. Players type it once when joining.",
    "passwordInvalid": "Use up to 16 letters, digits, - or _.",
    "titleTooShort": "The game name needs at least 3 characters.",
    "submit": "Create & open lobby",
    "creating": "Creating…",
    "youAreShowman": "You'll be the showman. Players join with the link or room code.",
    "package": "Package",
    "changePackage": "Change package",
    "noPackage": "Choose a package first.",
    "pickPackage": "Browse packages",
    "rules": {
      "title": "Rules",
      "falseStart": "False starts",
      "falseStartHelp": "The buzzer opens once the question has played. A player who presses earlier is locked out for 3 seconds. Turn off to let players press at any time.",
      "pressMode": "Who answers when several players press",
      "modes": {
        "random_within_window": "Fair draw",
        "first_wins": "Fastest press"
      },
      "modeHelp": {
        "random_within_window": "Everyone who presses within 0.3 s of the first press has an equal chance, so a faster connection doesn't win.",
        "first_wins": "The first press that reaches the server answers."
      },
      "penalty": "Wrong answers cost points",
      "penaltyHelp": "A wrong answer after pressing the buzzer subtracts the question's price. Turn off for a friendlier game. Stakes are always lost on a wrong answer.",
      "roundLimit": "Round time limit",
      "roundLimitHelp": "When time is up, the round ends after the question being played, even if questions are left.",
      "noLimit": "No limit",
      "minutes": "{{count}} min",
      "seconds": "{{count}} sec.",
      "timers": "Timers",
      "timer": {
        "answerMs": "Time to press the buzzer",
        "answerSubmitMs": "Time to answer after pressing",
        "stakeMs": "Time for each stake",
        "secretTransferMs": "Time to hand over a secret question",
        "allPlayAnswerMs": "Time to write when everyone answers",
        "finalAnswerMs": "Time for the final answer"
      },
      "startMode": "Start game",
      "startAutomatic": "When everyone is ready",
      "startManual": "When the showman decides"
    }
  },
  "settings": {
    "title": "Settings",
    "guestAccount": "Guest account",
    "displayName": "Display name",
    "nameRequired": "Your name can't be empty.",
    "save": "Save",
    "saved": "Saved ✓",
    "look": "Look",
    "theme": "Theme",
    "themes": {
      "midnight": "Midnight",
      "daylight": "Daylight",
      "broadcast": "Broadcast",
      "boldPop": "Bold Pop",
      "softParty": "Soft Party"
    },
    "comingLater": "Coming later",
    "language": "Language",
    "feel": "Sound and motion",
    "sound": "Sound effects",
    "reduceMotion": "Reduce motion",
    "volume": "Media volume",
    "signOut": "Sign out",
    "guestSignOutHelp": "Guest accounts can't sign back in: you'll get a new guest next time.",
    "changeAvatar": "Change photo",
    "avatarSaving": "Saving photo…",
    "avatarSaved": "Photo updated",
    "avatarErrors": {
      "notImage": "That file isn't a picture we can read.",
      "tooBig": "That picture is over 20 MB. Pick a smaller one.",
      "generic": "Couldn't save the photo. Try again."
    },
    "signOutFailed": "Couldn't sign out. Check your connection and try again."
  },
  "join": {
    "notFound": "Game not found",
    "notFoundHelp": "There's no open game with code {{code}}. It may have ended, or the code has a typo.",
    "finished": "Finished",
    "finishedHelp": "This game has ended.",
    "signedInAs": "You'll join as {{name}}.",
    "yourName": "Your name",
    "guestHelp": "We'll create a guest account with this name.",
    "otherSignIn": "Other sign-in options",
    "password": "Game password",
    "passwordRequired": "This game needs a password.",
    "asPlayer": "Join as player",
    "watch": "Spectate",
    "lobbyHelp": "Players buzz and score. Spectators watch everything but can't answer.",
    "playingHelp": "The game is in progress. Take a free seat and play from the next question, or watch.",
    "fullHelp": "All seats are taken. You can watch and take a seat if one frees up.",
    "passwordInvalid": "Use 1–16 Latin letters, digits, - or _."
  },
  "game": {
    "joining": "Joining the game…",
    "joinFailed": "Couldn't join this game",
    "authFailed": "Your session expired. Sign in again.",
    "tryAgain": "Try again",
    "backHome": "Back to games",
    "over": "Game over",
    "finalRound": "Final round",
    "watching_one": "{{count}} watching",
    "watching_other": "{{count}} watching",
    "pause": "Pause",
    "resume": "Resume",
    "scores": "Scores",
    "noPlayers": "No players are seated. You can pick questions yourself.",
    "roundLabel": "Round {{n}} · {{name}}",
    "rounds": {
      "title": "Package rounds",
      "position": "{{current}} of {{total}}",
      "open": "Rounds. {{position}}. Current: {{name}}",
      "done": "Completed",
      "current": "Now",
      "next": "Next"
    },
    "you": "You:",
    "youAre": "You are {{role}}",
    "delete": "Delete game",
    "deleteConfirm": "Delete this game for everyone?",
    "deleteYes": "Yes, delete",
    "deleteNo": "Cancel",
    "roundEndsIn": "Round ends in {{time}}",
    "roundTimeUp": "Last question of the round",
    "takenOver": "Opened somewhere else",
    "takenOverHelp": "Your account joined this game in another tab or on another device, so this one stopped. Your seat and score are safe.",
    "takeOver": "Play here",
    "leaving": "Leaving…",
    "leaveFailed": "Could not leave the game. Please try again."
  },
  "lobby": {
    "leave": "Leave lobby",
    "youAre": "You are",
    "kicker": "Lobby · waiting for players",
    "players": "Players",
    "readyCount": "{{count}} of {{total}} ready",
    "openSlot": "Open slot",
    "waitingForPlayer": "Waiting for a player",
    "clickToSit": "Click to sit here",
    "takeSlot": "Take seat {{n}}",
    "ready": "Ready",
    "notReady": "Not ready yet",
    "offline": "Offline — seat kept",
    "spectators": "Spectators",
    "watching_one": "{{count}} watching",
    "watching_other": "{{count}} watching",
    "spectatorsHelp": "Spectators see everything but can't buzz or bid.",
    "youreSeated": "You're in seat {{n}} as a player",
    "imReady": "I'm ready",
    "readyUndo": "✓ Ready — click to undo",
    "readyHelp": "The game starts when every connected player is ready. The showman can also start it earlier.",
    "waitingForHost": "Waiting for {{name}} to start · {{ready}} of {{total}} ready.",
    "watchInstead": "Watch instead",
    "youreWatching": "You're watching",
    "spectatorHelp": "Take a free seat to play. You can switch back any time before the game starts.",
    "noSeats": "All seats are taken. A seat may free up before the start.",
    "takeSeat": "Take a seat",
    "startTitle": "Start the game",
    "checkPackage": "Package loaded",
    "checkPlayers_one": "{{count}} player in the room",
    "checkPlayers_other": "{{count}} players in the room",
    "checkNoPlayers": "No players yet — share the invite",
    "checkAllReady": "Everyone is ready",
    "checkNotReady_one": "{{count}} player isn't ready yet",
    "checkNotReady_other": "{{count}} players aren't ready yet",
    "start": "Start game",
    "startHelp": "You can start any time. When everyone is ready, the game starts by itself.",
    "startAloneHelp": "You can start alone to try the package, but nobody will be able to buzz.",
    "invite": "Invite",
    "inviteLink": "Invite link",
    "copy": "Copy",
    "copied": "Copied",
    "roomCode": "Room code",
    "password": "Password",
    "kick": "Remove {{name}} from the game",
    "moveToSpectators": "Move {{name}} to spectators",
    "moreSeats_one": "{{count}} more open seat",
    "moreSeats_other": "{{count}} more open seats",
    "readyManualHelp": "Mark yourself ready. The showman decides when to start.",
    "waitingForReady": "{{ready}} / {{total}} players ready. Waiting for everyone to be ready.",
    "startManualHelp": "Readiness is a signal to you. The game starts only when you press Start.",
    "automaticMode": "Automatic start · starts when every connected player is ready.",
    "manualMode": "Showman starts · ready players wait for the showman.",
    "showmanOpen": "Showman seat is open",
    "showmanHelp": "Runs the game and judges answers",
    "becomeShowman": "Become showman",
    "packageOverview": "Rounds and themes",
    "packageUnavailable": "Could not load the package overview.",
    "finalRound": "Final round"
  },
  "banner": {
    "reconnecting": "Connection lost — reconnecting…",
    "reconnectingHelp": "Your seat and score are kept. The screen catches up as soon as you're back."
  },
  "pause": {
    "title": "Game paused",
    "waiting": "Waiting for the showman to continue the game."
  },
  "chat": {
    "title": "Chat",
    "empty": "No messages yet. Say hi!",
    "message": "Message",
    "placeholder": "Message — Space won't buzz while typing",
    "muted": "The showman muted you",
    "send": "Send",
    "someone": "Someone",
    "unread_one": "{{count}} unread message",
    "unread_other": "{{count}} unread messages",
    "log": {
      "start": "started the game",
      "pause": "paused the game",
      "unpause": "resumed the game",
      "reveal": "revealed the answer",
      "buzzerOpen": "opened the buzzer early",
      "nextRound": "skipped to the next round",
      "nextRoundNamed": "skipped to the next round: {{round}}",
      "pick": "picked {{theme}} for {{price}}",
      "toggleRemoved": "removed {{theme}} for {{price}} from the board",
      "toggleRestored": "put {{theme}} for {{price}} back on the board",
      "answerRight": "judged {{player}} right ({{points}})",
      "answerWrong": "judged {{player}} wrong ({{points}})",
      "answerSkipped": "skipped {{player}}'s answer ({{points}})",
      "undo": "took back the ruling on {{player}} ({{points}})",
      "joinMode": "set who can join: {{mode}}",
      "kick": "removed {{player}} from the game",
      "restrictBanned": "banned {{player}}",
      "restrictRestricted": "made {{player}} a spectator only",
      "restrictMuted": "muted {{player}}",
      "restrictCleared": "lifted the restrictions on {{player}}",
      "role": "made {{player}} a {{role}}",
      "score": "set {{player}}'s score to {{score}}",
      "slot": "moved {{player}} to seat {{slot}}",
      "turn": "gave the pick to {{player}}",
      "turnNone": "took the pick",
      "secret": "gave the question to {{player}}",
      "reviewRight": "judged {{player}}'s answer right",
      "reviewWrong": "judged {{player}}'s answer wrong",
      "theme": "removed the theme {{theme}}",
      "rules": "changed the rules: {{changes}}",
      "ruleOn": "on",
      "ruleOff": "off"
    },
    "system": "System"
  },
  "menu": {
    "title": "Game menu",
    "shortcuts": "Keyboard shortcuts",
    "keys": {
      "buzz": "Buzz",
      "option": "Pick answer option",
      "judge": "Correct / wrong (showman)",
      "chat": "Open chat",
      "menu": "This menu"
    },
    "feel": "Sound and motion",
    "host": "Showman tools",
    "hostHelp": "Use Manage players to fix a score, hand over the turn or remove someone. Deleting the game sends everyone home.",
    "skipQuestion": "Skip this question",
    "nextRound": "Go to next round",
    "spectate": "Switch to spectator",
    "leave": "Leave game",
    "skipReveal": "Skip the answer",
    "managePlayers": "Manage players",
    "hostShort": "Host",
    "undoRuling": "Undo last ruling",
    "boardEdit": "Remove questions",
    "boardEditDone": "Done removing",
    "joinMode": "Who can join",
    "joinModes": {
      "open": "Anyone",
      "spectators_only": "Spectators only",
      "closed": "Nobody new"
    },
    "rules": {
      "title": "Game rules",
      "help": "Changes apply from the next timer or question; a timer already running keeps its time. Everyone sees the change in the chat.",
      "save": "Save",
      "saving": "Saving…",
      "reset": "Undo changes"
    },
    "info": {
      "title": "Game info",
      "playersHelp": "{{count}} players in the game now; you can't make fewer seats than that.",
      "newPassword": "New password",
      "passwordPlaceholder": "Leave empty to keep the current one",
      "passwordHelp": "Letters, digits, _ and -, up to 16. Players already in the game stay.",
      "saved": "Saved ✓"
    }
  },
  "keys": {
    "space": "Space"
  },
  "phases": {
    "lobby": "Lobby",
    "choosing": "Choosing",
    "media": "Loading question",
    "showing": "Ready to buzz",
    "answering": "Answering",
    "reveal": "Answer",
    "secret_transfer": "Secret question",
    "stake_bidding": "Stake · bidding",
    "final_elimination": "Theme elimination",
    "final_bidding": "Final · bidding",
    "final_answering": "Final · answering",
    "final_reviewing": "Final · review",
    "finished": "Game over",
    "all_play_bidding": "Everyone · stakes",
    "all_play_answering": "Everyone answers",
    "all_play_reviewing": "Everyone · review"
  },
  "questionOpening": {
    "opening": "Opening question",
    "waiting": "Waiting for all players to download media..."
  },
  "reasons": {
    "question_opening": "Opening question — wait for the transition to finish",
    "wrong_role": "Only players can do this",
    "wrong_role_watch": "You're watching — spectators can't buzz",
    "wrong_phase": "Not available right now",
    "not_your_turn": "Not your turn",
    "already_done": "You already answered this one",
    "not_eligible": "You joined after this question started",
    "waiting_for_media": "Buzzer opens when everyone has the question",
    "waiting_for_server": "Sending…",
    "connection_lost": "Reconnecting — actions are paused",
    "paused": "The game is paused",
    "skipped": "You passed on this question",
    "false_start": "You pressed too early — wait a moment"
  },
  "chips": {
    "offline": "offline",
    "picks": "picks",
    "loading": "loading…",
    "answering": "answering",
    "passed": "passed",
    "givingAway": "giving away",
    "choosingPrice": "choosing price",
    "bidding": "bidding",
    "removing": "removing",
    "bidPlaced": "bid placed",
    "answered": "answered",
    "typing": "typing",
    "someone": "someone"
  },
  "board": {
    "caption": "Round board: {{round}}",
    "picker": "{{name}} picks",
    "cell": "{{theme}}, {{price}}",
    "played": "{{theme}}, {{price}}, already played",
    "editHint": "Click a question to take it off the board, or click a crossed-out one to put it back."
  },
  "question": {
    "region": "Question",
    "image": "Question image",
    "audio": "Question audio",
    "getReady": "Get ready…",
    "mediaReady": "{{ready}} of {{total}} players have the question",
    "noContent": "The showman reads this question out loud.",
    "noRiskHelp": "No risk: a wrong answer costs nothing",
    "options": "Answer options",
    "optionsSoon": "Answer options appear in a moment…",
    "showmanPreview": "Only you can see this until every player has loaded it.",
    "mediaFailed": {
      "image": "Couldn't load the image",
      "video": "Couldn't load the video",
      "audio": "Couldn't load the audio"
    },
    "mediaFailedHelp": "The file server isn't responding. The showman can read the question out loud or skip it.",
    "openFile": "Open the file",
    "mediaLoading": "Loading…",
    "audioPlaying": "Listen",
    "audioWaiting": "The audio plays when the question opens",
    "enableSound": "Tap to turn the sound on",
    "step": "Part {{current}} of {{total}}",
    "stepsLabel": "Question parts",
    "recap": "Question: {{text}}",
    "audioEnded": "Finished",
    "replay": "Replay presentation",
    "optionNumber": "Option {{n}}",
    "mediaTab": "Media",
    "textTab": "Text",
    "scrollHint": "Scroll to read more",
    "expandOption": "Open option {{n}}"
  },
  "showman": {
    "panel": "Only you can see this",
    "onlyYou": "Answer · only you see this",
    "answer": "Correct answer",
    "noAnswerText": "No answer text in the package",
    "hint": "Hint: {{hint}}",
    "answering": "<player>{{name}}</player> answers:",
    "sayingOutLoud": "Answering out loud",
    "emptySubmission": "No answer text was sent.",
    "alreadyAnswered": "Already answered",
    "comment": "Instruction for the showman",
    "alsoRight": "Also right: {{answers}}",
    "notRight": "Not right: {{answers}}",
    "number": "Right number: {{number}}{{deviation}}",
    "autoChecked": "The game checks recognized answers automatically."
  },
  "reveal": {
    "answer": "The answer",
    "gotIt": "<player>{{name}}</player> answers correctly · <points>{{points}}</points>",
    "nobody": "No one answered correctly.",
    "correctPlayers": "Correct answers: {{players}}",
    "correctCount": "Correct: {{correct}}/{{total}}",
    "noSubmissions": "No one submitted an answer.",
    "unresolved": "Some answers have not been judged.",
    "playerFallback": "Player {{id}}",
    "submitted": "<player>{{name}}</player> answered: “{{answer}}”",
    "alsoRight": "Also accepted: <answers>{{answers}}</answers>",
    "authors": "By {{names}}",
    "sources": "Source: {{list}}"
  },
  "secret": {
    "youPicked": "You picked a secret question. Who should answer it?",
    "picked": "<player>{{name}}</player> picked a secret question and is choosing who answers.",
    "ruleAny": "It can go to any player, including the one who picked it. They answer alone — no buzzer.",
    "ruleExcept": "It must go to another player. They answer alone — no buzzer.",
    "giveTo": "Give the question to",
    "prices": "Prices to pick from",
    "pickPriceYou": "The question is yours — pick its price",
    "pickPrice": "<player>{{name}}</player> got the question and picks its price"
  },
  "stake": {
    "kicker": "Stake question · auction",
    "rules": "The question goes to the highest bidder, who answers alone. Starting price {{start}}, max {{max}}.",
    "noLimit": "your score",
    "bids": "Bids, in turn order",
    "passed": "passed",
    "theirTurn": "their turn",
    "bid": "bid",
    "waiting": "waiting"
  },
  "final": {
    "mediaTimedOut": "Some players could not load the media in time. The question started anyway; some content may be missing.",
    "themesTitle": "Final round themes",
    "themesHelp": "Players take turns removing a theme. The last one left is the final question.",
    "removed": "Removed",
    "remove": "Remove",
    "finalTheme": "Final theme",
    "removeTheme": "Remove theme {{name}}",
    "themeRemoved": "{{name}}, removed",
    "theme": "Final round · {{name}}",
    "bidPrompt": "Place your bid before you see the question.",
    "bidPlaced": "bid placed",
    "bidding": "bidding",
    "answered": "answered",
    "typing": "typing",
    "answers": "Final answers",
    "bid": "bid",
    "noAnswer": "No answer",
    "judging": "Being judged",
    "autoLoss": "No answer · {{points}}"
  },
  "finished": {
    "wins": "{{name}} wins!",
    "tie": "It's a tie!",
    "noPlayers": "Game over",
    "podium": "Podium",
    "place": "Place {{n}}"
  },
  "judge": {
    "correct": "Correct",
    "wrong": "Wrong",
    "more": "More rulings",
    "double": "×2 {{points}}",
    "correctDoubleLabel": "Right, double points: +{{points}}",
    "wrongDoubleLabel": "Wrong, double penalty: −{{points}}",
    "skipZero": "Skip, 0"
  },
  "bid": {
    "quick": "Quick bids",
    "slider": "Bid amount slider",
    "detailsUnavailable": "Bidding details are unavailable. Wait for the game to update.",
    "afterAllIn": "After an all-in, only all-in or pass is allowed.",
    "noRegularBid": "A regular bid is unavailable.",
    "waitTimer": "No bid is available. Wait for the timer.",
    "amount": "Your bid",
    "bid": "Bid {{amount}}",
    "range": "Bid {{min}} – {{max}}",
    "allIn": "All-in {{amount}}",
    "pass": "Pass"
  },
  "admin": {
    "manage": "Manage {{name}}",
    "score": "Score",
    "setScore": "Set score",
    "scoreHelp": "Everyone sees the change in the score bar.",
    "giveTurn": "Give them the turn",
    "isTurn": "It's their turn",
    "toSpectators": "Move to spectators",
    "kick": "Remove from game",
    "mute": "Mute in chat",
    "unmute": "Unmute",
    "muteHelp": "They stay in the game but can't send chat messages.",
    "restrict": "Keep as spectator",
    "unrestrict": "Allow playing again",
    "restrictHelp": "Moves them to spectators and stops them from taking a player seat.",
    "ban": "Ban from this game",
    "banConfirm": "Yes, ban {{name}}",
    "banHelp": "Removes them and they can't rejoin this game."
  },
  "announce": {
    "correct": "{{name}} is correct, {{points}}",
    "wrong": "{{name}} is wrong, {{points}}",
    "skipped": "{{name}}'s answer was skipped, {{points}}",
    "yourTurn": "Your turn"
  },
  "dock": {
    "region": "Your action",
    "next": "What happens next",
    "sending": "Sending…",
    "reconnecting": "Reconnecting",
    "offlineInfo": "Actions are paused until you're back",
    "paused": "Paused",
    "choosing": {
      "yourTurn": "Your turn to pick",
      "pickInfo": "Pick any amber cell on the board",
      "isPicking": "<player>{{name}}</player> is picking",
      "showmanPicks": "The showman picks the next question",
      "showmanStatus": "<player>{{name}}</player> picks next",
      "youPick": "Pick the next question",
      "showmanInfo": "Wait for the player to pick, or pick for them",
      "pickAny": "Pick any cell on the board",
      "randomQuestion": "Pick random question",
      "noQuestions": "No questions left",
      "next": "The question opens for everyone as soon as it's picked.",
      "nextYou": "The question opens for everyone right after you pick.",
      "unknownShowman": "A player picks next — or pick for them",
      "unknown": "First pick",
      "unknownInfo": "If it's your turn, pick any cell on the board",
      "watching": "You're watching the pick"
    },
    "media": {
      "status": "{{ready}} of {{total}} players ready",
      "finalWait": "Waiting for players to load the final question.",
      "finalNext": "The final question starts when the media is ready.",
      "next": "The buzzer opens as soon as every player has loaded the question."
    },
    "showing": {
      "status": "Players can buzz now",
      "open": "Buzzer is open",
      "buzz": "Buzz!",
      "pass": "Pass",
      "unpass": "Undo pass",
      "wrongCost": "Wrong: −{{points}} and the buzzer reopens for the others",
      "wrongFree": "Wrong: no penalty",
      "next": "First to buzz answers. Right: +{{points}}. {{wrong}}.",
      "showmanStatus": "Waiting for a player to buzz",
      "revealAnswer": "Nobody knows — reveal the answer",
      "showmanNext": "If the timer runs out with no buzz, the answer is revealed automatically.",
      "wait": "Buzzer opens after the question",
      "waitButton": "Wait for it…",
      "earlyHint": "Pressing before the buzzer opens locks you out for 3 seconds.",
      "locked": "Too early! You can press again in {{seconds}} sec.",
      "nextWindow": "Everyone who presses within a split second of the first has an equal chance. Right: +{{points}}. {{wrong}}.",
      "showmanWait": "The question is playing — the buzzer opens after it",
      "openBuzzer": "Open buzzer now",
      "showmanNextEarly": "The buzzer opens when the question finishes. Open it now to let players buzz early.",
      "inDraw": "In the draw…"
    },
    "answering": {
      "autoSubmitted": "<player>{{name}}</player> sent an answer — waiting for the result",
      "autoSubmittedHelp": "The answer was sent. Wait for the result or skip without points.",
      "questionLoading": "Waiting for question details.",
      "autoWait": "<player>{{name}}</player> is answering — wait for their action",
      "autoWaitHelp": "The player must select, enter, or mark an answer.",
      "autoWaitNext": "The answer will be checked automatically when possible.",
      "judge": "<player>{{name}}</player> is answering — judge it",
      "showmanNext": "Correct: {{name}} scores and picks next. Wrong: −{{points}} and the buzzer reopens.",
      "showmanNextSingle": "Only {{name}} answers this one. Either way the answer is revealed next.",
      "you": "You're answering!",
      "pickOption": "Pick an option or press its number",
      "typeLabel": "Your answer",
      "typePlaceholder": "Say it out loud or type it here",
      "send": "Send",
      "sent": "Sent ✓",
      "giveUp": "Give up",
      "autoNext": "Recognized answers are checked automatically. If no result arrives, the showman can skip without points.",
      "youNext": "The showman judges your answer. Wrong costs points and the buzzer reopens for the others.",
      "choiceNext": "Recognized answers are checked automatically. If no result arrives, the showman can skip without points.",
      "youNextSingle": "The showman judges your answer. Right or wrong, the answer is revealed next.",
      "other": "<player>{{name}}</player> is answering",
      "wait": "Wait for the showman's call",
      "otherNext": "If {{name}} is wrong, the buzzer reopens for everyone else.",
      "otherNextSingle": "Only {{name}} answers this question.",
      "showmanChoice": "The game checks {{name}}'s answer when possible. Judge it if review is needed.",
      "numberPlaceholder": "Type a number"
    },
    "reveal": {
      "correct": "<player>{{name}}</player> answers correctly · <points>{{points}}</points>",
      "nobody": "Here's the answer",
      "continue": "Continue",
      "info": "Back to the board in a moment",
      "next": "{{name}} picks the next question.",
      "nextBoard": "Back to the board next."
    },
    "secret": {
      "choose": "Choose who answers",
      "giveQ": "Give it to <player>{{name}}</player>?",
      "otherChoosing": "<player>{{name}}</player> is choosing who answers",
      "give": "Give to {{name}}",
      "pickFirst": "Pick a player first",
      "wait": "Wait — you might get this question",
      "next": "They must answer: +{{points}} if right, −{{points}} if wrong.",
      "nextNoPrice": "They must answer alone.",
      "priceYou": "Pick the price of your question",
      "priceOther": "<player>{{name}}</player> is picking the price",
      "priceWait": "Waiting for {{name}} to pick a price",
      "priceNext": "Right answer wins the picked price, wrong costs it. If time runs out, the lowest price is used.",
      "priceAbove": "Choose the question price above"
    },
    "stake": {
      "waitFor": "Waiting for <player>{{name}}</player>'s bid",
      "watching": "Players are bidding — nothing to do yet",
      "beat": "Your bid — beat {{amount}}",
      "open": "Your bid",
      "next": "Highest bid wins the question and answers alone: + bid if right, − bid if wrong. Passing is final."
    },
    "final": {
      "elimYou": "Your turn — remove one theme",
      "elimOther": "<player>{{name}}</player> removes a theme",
      "elimShowman": "<player>{{name}}</player> removes a theme",
      "elimInfo": "Click a theme you don't want",
      "elimNext_one": "{{count}} theme left — it becomes the final question.",
      "elimNext_other": "{{count}} themes left. Players take turns until one remains.",
      "bidRange": "Bid 1 – {{max}}",
      "placeBid": "Place bid",
      "bidSubmitted": "Bid submitted",
      "bidLocked": "Your bid: {{amount}}",
      "waitOthers": "{{done}} of {{total}} done — waiting for the others",
      "bidsIn": "{{done}} of {{total}} bids in",
      "bidShowman": "Players are placing hidden bids",
      "bidNext": "Bids stay hidden until the review. Players with 0 or less sit the final out.",
      "sitOut": "You sit this final out",
      "typeAnswer": "Type your answer · bid {{amount}}",
      "pointAnswer": "Pick a point · bid {{amount}}",
      "pointNext": "Select a point on the picture to submit. If time runs out without an answer, the bid is lost.",
      "answerLabel": "Your final answer",
      "answerPlaceholder": "Type your answer",
      "submit": "Submit",
      "answerLocked": "Answer locked in",
      "answersIn": "{{done}} of {{total}} answers in",
      "answerShowman": "Players are answering",
      "contentPlaying": "Question in progress",
      "contentWait": "Watch the question first.",
      "contentNext": "Answering opens after the question finishes.",
      "answerNext": "Answers are revealed in the review. Whatever you typed is sent when time runs out.",
      "reviewStatus": "{{done}} of {{total}} answers judged",
      "reviewShowman": "Judge each answer on the stage",
      "reviewWait": "The showman is judging the answers",
      "reviewNext": "Scores update as each answer is judged. The winner is shown after the last one."
    },
    "finished": {
      "place": "You finished #{{n}}",
      "status": "Thanks for playing",
      "back": "Back to games",
      "next": "Host another game with any package, or join an open one."
    },
    "allPlay": {
      "stakeWatch": "Players are making their stakes",
      "stakeLocked": "Stake placed",
      "stakeNext": "When every stake is in, the question is shown to everyone.",
      "typeAnswer": "Type your answer — everyone answers this one",
      "answerWatch": "Players are writing their answers",
      "answerNextStakeAuto": "Valid answers are checked automatically; the showman reviews unrecognized answers. Right wins your stake; wrong loses it.",
      "answerNextNoRiskAuto": "Valid answers are checked automatically; the showman reviews unrecognized answers. Right wins {{points}}; wrong costs nothing.",
      "answerNextStake": "When time is up the showman judges every answer. Right wins your stake, wrong loses it.",
      "answerNextNoRisk": "When time is up the showman judges every answer. Right wins {{points}}, wrong costs nothing.",
      "reviewShowman": "Judge each answer on the stage",
      "reviewNext": "Once every answer is judged, the right answer is revealed."
    }
  },
  "errors": {
    "connection_lost": "You're offline. Reconnecting…"
  },
  "notices": {
    "joined": "{{name}} joined",
    "back": "{{name}} is back",
    "left": "{{name}} left — their seat and score are kept",
    "kicked": "{{name}} was removed from the game",
    "stakeWinner": "{{name}} won the auction at {{amount}} and answers alone",
    "secretTransfer": "The secret question goes to {{name}}",
    "scoreChanged": "The showman set {{name}}'s score to {{score}}",
    "turnChanged": "{{name}} picks next"
  },
  "players": {
    "title": "Players and scores",
    "button": "Players",
    "scores": "Scores",
    "none": "No players are seated yet.",
    "picksNext": "picks next",
    "manage": "Manage",
    "noShowman": "No showman right now",
    "noSpectators": "Nobody is watching.",
    "seat": "Seat as player",
    "showmanHelp": "Manage a player to fix their score, give them the turn, move them to spectators or remove them.",
    "viewAvatar": "Open avatar of {{name}}",
    "avatar": "Avatar of {{name}}",
    "currentValue": "Current question value",
    "lastValue": "Last question value",
    "valueUnavailable": "The previous question value is not available. Use player management to set a score.",
    "addScore": "Add {{amount}} to {{name}}",
    "subtractScore": "Subtract {{amount}} from {{name}}"
  },
  "upload": {
    "finalMedia": {
      "unavailable": "Could not read the duration of {{name}} for the final question. Check the file and try again.",
      "tooLong": "The duration for {{name}} exceeds two minutes. Shorten the file or its display time for the final question."
    },
    "pointImageDimensions": "Could not read the first image dimensions for a point answer. Check the image and try again.",
    "back": "Packages",
    "title": "Upload a package",
    "lead": "Bring a SIGame .siq pack or an OpenQuester .oq export. You'll see what's inside before anything is uploaded.",
    "signInFirst": "Sign in to upload packages.",
    "guestTitle": "Guest accounts can't upload packages",
    "guestHelp": "A package needs an owner who can come back to it. Sign in with Discord to upload, and your packages stay with your account.",
    "discordUnavailable": "Discord sign-in isn't switched on for this site yet, so uploading isn't available here.",
    "drop": "Drop a package file here",
    "formats": "SIGame .siq (formats 4 and 5) or OpenQuester .oq.",
    "choose": "Choose a file",
    "reading": "Reading {{name}}…",
    "readErrors": {
      "wrongType": "That isn't a .siq or .oq file.",
      "notZip": "This file is damaged or isn't a package archive.",
      "noContentXml": "This .siq file has no content.xml, so there's nothing to read.",
      "badContentXml": "The package description inside this .siq file is broken.",
      "noContentJson": "This .oq file has no content.json, so there's nothing to read.",
      "badContentJson": "The package description inside this .oq file is broken.",
      "generic": "Couldn't read this file.",
      "otherSource": "This file isn't the one this package was uploaded from, so it can't finish that upload. Upload it as a new package instead.",
      "allHtmlQuestions": "No usable questions remain after import. Other questions may have missing media.",
      "ambiguousManifest": "This archive contains multiple conflicting package manifests."
    },
    "format": {
      "siq": "SIGame package",
      "oq": "OpenQuester package"
    },
    "questionCount_one": "{{count}} question",
    "questionCount_other": "{{count}} questions",
    "mediaCount_one": "{{count}} media file · {{size}}",
    "mediaCount_other": "{{count}} media files · {{size}}",
    "noQuestions": "There are no playable questions in this file, so there's nothing to upload.",
    "warningsTitle_one": "{{count}} thing was adjusted while reading",
    "warningsTitle_other": "{{count}} things were adjusted while reading",
    "warningsHelp": "The package still uploads. These questions may look different from the original.",
    "warnings": {
      "missingFile": "Media file {{detail}} isn't in the archive, so it was left out.",
      "externalMedia": "Linked media ({{detail}}) can't be uploaded and was left out.",
      "emptyQuestion": "Question has no text or media, so it was skipped.",
      "noAnswer": "Question has no answer. The showman will judge it without one.",
      "choiceAsSimple": "Choice question has fewer than two options, so it plays as a regular question.",
      "choiceCorrectUnresolved": "The correct option needs repair. Open the question in the editor and choose it again.",
      "unknownType": "Question type “{{detail}}” isn't supported yet and plays as a regular question.",
      "finalAsSimple": "A final round outside the last position was converted to a regular round. Review its questions and prices.",
      "extraFinalQuestions": "Only the first question of this final theme was imported; {{detail}} additional questions were left out. Review the source archive.",
      "hashMismatch": "Media file {{detail}} is damaged and was left out.",
      "htmlQuestionRemoved": "Unsupported HTML question removed."
    },
    "showAll": "Show all {{count}}",
    "showFewer": "Show fewer",
    "upload": "Upload package",
    "another": "Choose another file",
    "progressLabel": "Upload progress",
    "creating": "Creating the package…",
    "sending": "Uploading media {{done}} of {{total}} · {{sent}} of {{size}}",
    "keepOpen": "Keep this page open until the upload finishes.",
    "done": "Package uploaded",
    "doneHelp": "“{{title}}” is ready. Host a game with it now or find it later in Packages.",
    "viewPackage": "View package",
    "partial_one": "{{count}} media file didn't upload",
    "partial_other": "{{count}} media files didn't upload",
    "retryFiles": "Retry those files",
    "tryAgain": "Try again",
    "networkError": "Lost connection while uploading. Check your network and try again.",
    "serverRejected": "The server didn't accept this package: {{message}}",
    "editFirst": "Edit before uploading",
    "compress": {
      "label": "Media is automatically prepared for upload",
      "help": "Files may be compressed or converted to another format. Media already prepared in the editor and files this browser cannot convert are kept as they are.",
      "progress": "Compressing media: {{done}} of {{total}} · {{before}} → {{after}}",
      "saved": "Media compressed from {{before}} to {{after}}.",
      "before": "Current media size",
      "estimate": "Estimated after compression",
      "estimating": "Estimating…",
      "estimateHelp": "Approximate media size, not the archive size. Actual results vary; files we cannot estimate keep their original size. Files already in storage may need no extra space."
    },
    "checking": "Checking that every file arrived…",
    "fileType": {
      "image": "Picture",
      "audio": "Sound",
      "video": "Video"
    },
    "fileState": {
      "waiting": "Waiting",
      "uploading": "Uploading",
      "done": "Uploaded",
      "failed": "Failed"
    },
    "showAllFiles_one": "Show all {{count}} file",
    "showAllFiles_other": "Show all {{count}} files",
    "unfinished": "{{uploaded}} of {{total}} media files are uploaded",
    "unfinishedHelp": "The package is saved, but nobody can start a game with it until all its media is uploaded. You can finish now or later from My packages.",
    "resumeLater": "Finish later",
    "uploadAnyway": "Upload anyway",
    "duplicates": {
      "title_one": "This package is already on OpenQuester",
      "title_other": "This package is already on OpenQuester {{count}} times",
      "help": "It was uploaded from the same file. Use it instead of making a copy, or upload anyway if you mean to.",
      "yours": "Your upload · {{when}}",
      "by": "By {{author}} · {{when}}",
      "resume": "Finish this upload",
      "open": "Open it"
    },
    "htmlRemoval": {
      "title": "Unsupported HTML questions",
      "explanation_one": "HTML questions are not supported. To continue, remove {{count}} question. The original file will not be changed.",
      "explanation_other": "HTML questions are not supported. To continue, remove {{count}} questions. The original file will not be changed.",
      "all": "No questions would remain, so this file cannot be imported.",
      "item": "{{round}} › {{theme}} › question {{number}} › {{price}}",
      "cancel": "Cancel",
      "confirm": "Remove and continue"
    },
    "includesMedia": "Images, audio and video inside the file are uploaded too."
  },
  "editor": {
    "storageFailed": "Couldn't update drafts on this device. Try again.",
    "drafts": "Drafts",
    "backToDrafts": "Back to drafts",
    "cancel": "Cancel",
    "optional": "(optional)",
    "undo": "Undo",
    "redo": "Redo",
    "export": "Export .oq",
    "exportHelp": "Download this package as an .oq file you can open here or in the OpenQuester app.",
    "savedAt": "Saved in this browser {{when}}",
    "notSaved": "Not saved yet",
    "missing": "This draft isn't in this browser",
    "missingHelp": "Drafts are kept in the browser they were made in. It may have been deleted, or made on another device.",
    "seconds_one": "{{count}} sec.",
    "seconds_other": "{{count}} sec.",
    "secondsShort": "sec.",
    "player": {
      "play": "Play",
      "pause": "Pause",
      "seek": "Seek",
      "mute": "Mute",
      "unmute": "Unmute",
      "volume": "Volume",
      "fullscreen": "Fullscreen",
      "fullscreenError": "Fullscreen is unavailable.",
      "exitFullscreen": "Exit fullscreen",
      "loading": "Loading media…",
      "error": "Unable to play this media."
    },
    "defaults": {
      "title": "New package",
      "round": "Round {{n}}",
      "theme": "First theme"
    },
    "home": {
      "title": "Package editor",
      "lead": "Build a package from scratch or open a .siq or .oq file, then publish it to play.",
      "newTitle": "Start from scratch",
      "newHelp": "One round with a five-question theme to fill in.",
      "new": "New package",
      "importTitle": "Open a file",
      "importHelp": "A SIGame .siq or an OpenQuester .oq export. You keep editing it here before publishing.",
      "import": "Open .siq or .oq",
      "drafts": "Your drafts",
      "draftsHelp": "Drafts stay in this browser until you publish them. Export .oq to move one to another device.",
      "noDrafts": "No drafts yet.",
      "draftMeta": "{{rounds}} rounds · {{questions}} questions · edited {{when}}",
      "published": "published",
      "deleteDraft": "Delete draft {{title}}",
      "deleteConfirm": "Delete the draft “{{title}}”? Its media is removed from this browser too."
    },
    "outline": {
      "label": "Package outline",
      "details": "Package details",
      "rounds": "Rounds",
      "addRound": "Add round",
      "untitled": "Untitled",
      "counts": "{{themes}} themes · {{questions}} questions"
    },
    "board": {
      "roundOf": "Round {{n}} of {{total}}",
      "roundName": "Round name",
      "roundNamePlaceholder": "Name this round",
      "roundType": "Round type",
      "roundTypes": {
        "simple": "Regular",
        "final": "Final"
      },
      "oneFinal": "A package has one final round, and it's already set.",
      "finalHelp": "In the final, players pick a theme, bet and answer one question. Each theme holds exactly one question with no price.",
      "addTheme": "Add theme",
      "roundActions": "Round actions",
      "noThemes": "This round has no themes yet",
      "noThemesHelp": "A theme is a row on the board. Add one and it starts with five questions to fill in.",
      "themeName": "Theme name",
      "themeNamePlaceholder": "Name this theme",
      "themeActions": "Actions for theme {{name}}",
      "dragTheme": "Drag to move this theme to another place or round",
      "questionCount_one": "{{count}} question",
      "questionCount_other": "{{count}} questions",
      "questionActions": "Actions for {{label}}",
      "emptyQuestion": "Empty question",
      "noText": "No text yet",
      "addQuestion": "Add",
      "addQuestionTo": "Add a question to {{name}}",
      "dropHere": "Drop here",
      "needsFix": "Needs fixing",
      "check": "Worth a look"
    },
    "actions": {
      "edit": "Edit",
      "move": "Move to…",
      "moveTheme": "Move theme to…",
      "duplicate": "Duplicate",
      "delete": "Delete",
      "deleteTheme": "Delete theme",
      "deleteRound": "Delete round"
    },
    "density": {
      "label": "Board view",
      "compact": "Compact cards, full question on hover",
      "cards": "Preview cards with media and answers"
    },
    "inspector": {
      "label": "Selected question",
      "resize": "Resize question inspector"
    },
    "playtest": {
      "title": "Interactive game preview",
      "description": "Local simulation of this unsaved question. No real game is created.",
      "loading": "Preparing question media…",
      "mediaError": "The question media could not be loaded. Check the files and try again.",
      "retry": "Try again",
      "fix": "Return to editing",
      "invalid": "This question is not finished yet.",
      "perspective": "View as",
      "player": "Player {{number}}",
      "showman": "Showman",
      "spectator": "Spectator",
      "continue": "Continue",
      "restart": "Restart",
      "pause": "Pause",
      "resume": "Resume",
      "controls": "Simulation controls",
      "local": "Local draft question preview.",
      "settings": "Test settings",
      "waiting": "Advance the content or wait for the buzzer before answering.",
      "legacy": "Preview uses the current image dimensions. The saved legacy question keeps its old server behavior until republished.",
      "theme": "Test theme",
      "round": "Test round",
      "final": "Final round",
      "number": "Number",
      "deviation": "The answer tolerance must be zero or greater.",
      "stakeLimit": "The maximum bid must be at least the question price for this auction.",
      "keepTheme": "Kept for the preview",
      "targetTheme": "{{name}} is kept for the preview question.",
      "finished": "This run is complete. Restart to try again.",
      "switchToPlayer": "Switch View as to a player who can act.",
      "judgeAnswers": "Judge the submitted answers using the controls below.",
      "switchToShowman": "Switch to the showman to judge the submitted answers."
    },
    "preview": {
      "mediaCount": "Media files: {{count}}",
      "mediaOnly": "Media answer",
      "openFull": "Select the question for the full preview.",
      "answer": "Answer",
      "pointAnswer": "Point on image",
      "pointUnavailable": "The point or its image is unavailable.",
      "noAnswer": "No answer yet",
      "noQuestion": "No question text or media yet",
      "hint": "Showman hint",
      "comment": "Comment",
      "maxBid": "Bids up to {{max}}",
      "allIn": "All-in allowed",
      "everyone": "everyone plays",
      "back": "Back",
      "readOnly": "Preview · {{rounds}} rounds · {{questions}} questions · read only"
    },
    "media": {
      "dragFile": "Drag file {{number}} to reorder",
      "moveEarlier": "Move file {{number}} earlier",
      "moveLater": "Move file {{number}} later",
      "pointUndoConfirm": "Undo changes the picture for the correct point. The current point will be cleared. Continue?",
      "sizeUnknown": "Size unknown",
      "image": "Image",
      "audio": "Audio",
      "video": "Video",
      "missing": "File missing",
      "add": "Add image, audio or video",
      "reading": "Reading…",
      "remove": "Remove file",
      "show": "Show",
      "dropMore": "Drop more files here",
      "errors": {
        "mediaType": "{{name}} isn't an image, audio or video file.",
        "mediaSize": "{{name}} is larger than 100 MB."
      }
    },
    "form": {
      "title": "Question for {{price}}",
      "finalTitle": "Final question",
      "description": "Edit the question, its answer and media.",
      "type": "Question type",
      "typeHelp": {
        "simple": "First to buzz answers",
        "stake": "Players bid to answer",
        "secret": "Given to another player",
        "noRisk": "No penalty, bonus points",
        "choice": "Pick from options",
        "hidden": "Price hidden on the board"
      },
      "price": "Price",
      "text": "Question text",
      "textPlaceholder": "What players see and the showman reads out",
      "questionMedia": "Shown with the question",
      "questionMediaHelp": "Drop images, audio or video here. A question needs text or media.",
      "textFirst": "Show the text first, then each file one at a time",
      "answer": "Correct answers",
      "answerHelp": "<strong>One accepted answer per line.</strong> Players see them after the answer is judged.",
      "hint": "Hint for the showman",
      "hintHelp": "Only the showman sees it, to judge close answers.",
      "answerMedia": "Shown with the answer",
      "answerMediaHelp": "Optional media revealed with the answer.",
      "comment": "Comment",
      "commentHelp": "Instruction for the showman before reading the question.",
      "options": "Options",
      "optionsHelp": "Two to eight options. Mark the correct one.",
      "option": "Option {{letter}}",
      "correct": "Correct",
      "removeOption": "Remove option {{letter}}",
      "addOption": "Add option",
      "settingsFor": "{{type}} settings",
      "maxBid": "Highest bid",
      "maxBidHelp": "Leave empty to allow all-in.",
      "stakeEveryone": "Everyone bids and answers",
      "multiplier": "Price multiplier",
      "noRiskEveryone": "Everyone plays it",
      "transferTitle": "Who can receive it",
      "transfer": {
        "any": "Any player",
        "exceptCurrent": "Anyone but the picker"
      },
      "allowedPrices": "Prices the receiver picks from",
      "allowedPricesHelp": "Optional: 2 to 5 prices separated by commas. Empty keeps the board price.",
      "showDelay": "Options appear after (sec.)",
      "showAnswer": "Answer reveal duration",
      "secondsUnit": "seconds",
      "revealRange": "Enter a duration from 2 to 30 seconds.",
      "revealMediaHelp": "Answer media determines the reveal timeline; this fallback duration does not apply.",
      "preview": "Preview",
      "save": "Save",
      "saveShortcut": "Ctrl+Enter saves",
      "unsaved": "You have unsaved changes to this question.",
      "discard": "Discard changes",
      "keepEditing": "Keep editing",
      "rightAnswers": "Also accept",
      "rightAnswersHelp": "<strong>One per line.</strong> An option matching any of these answers also counts as correct.",
      "wrongAnswers": "Wrong answers",
      "wrongAnswersHelp": "<strong>One per line.</strong> Common mistakes, so the showman can judge faster. Players never see them.",
      "authors": "Authors",
      "sources": "Sources",
      "sourcesHelp": "One per line: links or books. Shown with the answer.",
      "answerType": "How players answer",
      "answerTypes": {
        "text": "Text",
        "number": "Number",
        "point": "Point on image"
      },
      "answerTypeHelp": {
        "text": "The showman judges the answer.",
        "number": "The answer is checked automatically against the number.",
        "point": "The answer is checked automatically against a point on the image."
      },
      "answerNumber": "Right number",
      "answerNumberMissing": "Enter the right number",
      "deviation": "Allowed difference",
      "deviationHelp": "0 means exactly this number.",
      "pointHelp": "Click the right spot on the selected picture.",
      "radius": "Answer radius",
      "radiusLoading": "Loading image dimensions…",
      "radiusValue": "{{percent}}% · {{pixels}} px radius",
      "radiusLegacy": "This radius exceeds the slider range. It stays unchanged until you adjust it.",
      "pointLegacy": "This published point uses legacy checking until you publish it again from the web editor.",
      "pointNeedsImage": "Add a picture to the question first."
    },
    "timeline": {
      "add": "Add text step",
      "text": "Additional text {{number}}",
      "earlier": "Move step {{number}} earlier",
      "later": "Move step {{number}} later",
      "remove": "Remove text step {{number}}",
      "mainFirstHelp": "Shown first, before the media and other text steps.",
      "moveHandle": "Drag to reorder, or use the arrow keys",
      "moveStatus": "Moved to position {{number}}"
    },
    "move": {
      "questionTitle": "Move question",
      "themeTitle": "Move theme",
      "round": "Round",
      "theme": "Theme",
      "noThemes": "This round has no themes yet.",
      "position": "Position",
      "atEnd": "At the end",
      "before": "Before {{name}}",
      "confirm": "Move here"
    },
    "details": {
      "title": "Package details",
      "name": "Package title",
      "namePlaceholder": "Name your package",
      "description": "Description",
      "language": "Language",
      "noLanguage": "Not set",
      "age": "Age rating",
      "tags": "Tags",
      "tagsPlaceholder": "movies, music, 90s",
      "tagsHelp": "Separate tags with commas. They help people find your package.",
      "authorsHelp": "One per line. Shown on the package page."
    },
    "confirm": {
      "themeTitle": "Delete theme?",
      "roundTitle": "Delete round?",
      "themeBody_one": "“{{name}}” and its {{count}} question will be deleted. You can undo this.",
      "themeBody_other": "“{{name}}” and its {{count}} questions will be deleted. You can undo this.",
      "roundBody_one": "“{{name}}” with all its themes and {{count}} question will be deleted. You can undo this.",
      "roundBody_other": "“{{name}}” with all its themes and {{count}} questions will be deleted. You can undo this."
    },
    "changes": {
      "renamed": "Renamed",
      "questionSaved": "Question saved",
      "questionAdded": "Question added",
      "questionMoved": "Moved to {{to}}",
      "questionDeleted": "Question deleted",
      "themeAdded": "Theme added",
      "themeMoved": "Theme moved to {{to}}",
      "themeDeleted": "Theme deleted",
      "roundAdded": "Round added",
      "roundMoved": "Round moved",
      "roundDeleted": "Round deleted",
      "roundType": "Round type changed",
      "duplicated": "Duplicated",
      "detailsSaved": "Details saved",
      "pricesSet": "Prices set",
      "questionsPasted": "Questions added"
    },
    "empty": {
      "title": "An empty package",
      "help": "Add a round to start. Each round holds themes, and each theme holds questions."
    },
    "health": {
      "good": "Ready to publish",
      "needsAttention": "Can be published, a few things are worth a look",
      "broken_one": "{{count}} thing to fix before publishing",
      "broken_other": "{{count}} things to fix before publishing"
    },
    "severity": {
      "critical": "Must fix ({{count}})",
      "warning": "Worth a look ({{count}})",
      "info": "Suggestions ({{count}})"
    },
    "status": {
      "good_one": "Ready to publish · {{count}} question",
      "good_other": "Ready to publish · {{count}} questions",
      "review": "Review"
    },
    "publish": {
      "open": "Publish",
      "title": "Publish package",
      "publish": "Publish to OpenQuester",
      "help": "Publishing uploads the package and its media so you can host games with it.",
      "blocked_one": "Fix the {{count}} issue above first. Tap it to jump there.",
      "blocked_other": "Fix the {{count}} issues above first. Tap one to jump there.",
      "sending": "Uploading media {{done}} of {{total}}",
      "doneHelp": "Host a game with it now or find it later in Packages. The draft stays here for edits; publishing again updates this package (you can also publish it as a new one).",
      "saveChanges": "Save changes to the published package",
      "publishAsNew": "Publish as a new package instead",
      "notYours": "Only the package's author can change it. Publish it as a new package instead."
    },
    "issues": {
      "noTitle": "The package has no title.",
      "noRounds": "The package has no rounds.",
      "roundNoName": "The round has no name.",
      "roundNoThemes": "The round has no themes.",
      "themeNoName": "The theme has no name.",
      "themeNoQuestions": "The theme has no questions.",
      "questionEmpty": "The question has no text or media.",
      "noPrice": "The question has no price.",
      "priceRange": "The price must be between 0 and {{max}}.",
      "missingMedia": "A media file is missing from this browser. Add it again.",
      "choiceOptions": "A choice question needs 2 to 8 options (has {{count}}).",
      "choiceEmptyOption": "An option has no text.",
      "choiceNoCorrect": "No option is marked as correct.",
      "choiceCorrectUnresolved": "Choose the correct option again before publishing.",
      "secretPrices": "Pick 2 to 5 prices for the receiver, or leave the list empty (has {{count}}).",
      "multipleFinals": "Only one round can be the final.",
      "finalNotLast": "The final round has to be the last round.",
      "finalOneQuestion": "A final theme holds exactly one question (has {{count}}).",
      "finalTypeIgnored": "Final questions always play as regular questions; the type is ignored.",
      "noAnswer": "The question has no answer. The showman will judge without one.",
      "longText": "The text is very long and may not fit on screen.",
      "noLanguage": "Set a language so players can find the package.",
      "noDescription": "Add a short description.",
      "noTags": "Add a few tags.",
      "numberAnswerMissing": "Number answer without the right number",
      "pointAnswerMissing": "Point answer without a picture or the right spot"
    },
    "tools": {
      "pricesTitle": "Set prices for the round",
      "pricesHelp": "Every theme in this round gets the same prices, counting up from the first.",
      "firstPrice": "First price",
      "step": "Step",
      "pricesPreview": "Prices: {{prices}}…",
      "applyPrices": "Set prices",
      "pasteTitle": "Paste questions as text",
      "pasteHelp": "Each block is a theme: its name on the first line, then one question per line with the answer after “|” or “ — ”. A blank line starts the next theme. A number at the start of a line is the price.",
      "pasteLabel": "Questions",
      "pastePlaceholder": "Capitals\n100. The capital of France? | Paris\n200. The capital of Japan? | Tokyo\n\nPlanets\n100. The red planet? | Mars",
      "pasteSummary": "{{themes}} themes, {{questions}} questions.",
      "pasteMissing_one": "{{count}} question has no answer yet.",
      "pasteMissing_other": "{{count}} questions have no answer yet.",
      "pasteAdd": "Add to the round",
      "searchTitle": "Search the package",
      "searchPlaceholder": "Question, answer or theme",
      "searchCount_one": "{{count}} question found",
      "searchCount_other": "{{count}} questions found",
      "noText": "(no text)"
    },
    "saveFailed": "Changes aren't saved on this device (its storage may be full). They stay in this tab: retry, or export a file to keep them.",
    "saveRetry": "Retry saving",
    "importReportHide": "Hide this report",
    "exportMediaFailed": "Couldn't export: {{name}} could not be downloaded from storage. Check your connection and try again."
  },
  "panels": {
    "pin": "Pin {{name}}",
    "unpin": "Unpin {{name}}",
    "close": "Close {{name}}",
    "pinHelp": "Keep this panel open next to the game, also after a reload",
    "unpinHelp": "Pinned on this device. Click to unpin"
  },
  "adminPanel": {
    "title": "Admin",
    "overview": "Overview",
    "users": "Users",
    "system": "System",
    "noAccess": "This page is for admins.",
    "noAccessHelp": "Your account doesn't have admin access. Ask an admin if you need it.",
    "loadFailed": "Couldn't load this. Try again.",
    "totalUsers": "Users",
    "activeUsers": "Active",
    "guests": "Guests",
    "deletedUsers": "Deleted",
    "bannedUsers": "Banned",
    "uptime": "Server uptime",
    "redis": "Redis",
    "redisKeys_one": "{{count}} key",
    "redisKeys_other": "{{count}} keys",
    "down": "Down",
    "recentUsers": "Newest users",
    "guest": "Guest",
    "search": "Search by name, username or email",
    "status": "Status",
    "anyStatus": "Any",
    "statusActive": "Active",
    "statusBanned": "Banned",
    "statusDeleted": "Deleted",
    "type": "Type",
    "typeAll": "Everyone",
    "typeRegistered": "Registered",
    "typeGuest": "Guests",
    "actionFailed": "That didn't work. Try again.",
    "noUsers": "No users match.",
    "mutedUntil": "Muted until {{date}}",
    "mute": "Mute…",
    "unmute": "Unmute",
    "forHours_one": "For {{count}} hour",
    "forHours_other": "For {{count}} hours",
    "forWeek": "For a week",
    "ban": "Ban",
    "unban": "Unban",
    "confirmBan": "Confirm ban",
    "delete": "Delete",
    "confirmDelete": "Confirm delete",
    "restore": "Restore",
    "noHealthAccess": "Your account can't view system health.",
    "ping": "API",
    "ok": "OK",
    "eventLoop": "Event loop lag",
    "redisMemory": "Redis memory",
    "redisKeysLabel": "Redis keys",
    "memory": "Server memory",
    "refresh": "Refresh",
    "packages": "Packages",
    "games": "Games",
    "role": "Role",
    "roleUser": "User",
    "roleModerator": "Moderator",
    "roleAdmin": "Admin",
    "roleHelp": {
      "user": "No admin panel access.",
      "moderator": "Moderates people, games and packages. Tick extra permissions below if needed.",
      "admin": "Everything, including roles and permissions."
    },
    "permissions": "Permissions",
    "perm": {
      "get_all_users": "See the user list",
      "get_another_user": "See anyone's profile",
      "change_another_user": "Edit anyone's profile",
      "delete_another_user": "Delete and restore accounts",
      "delete_file": "Delete uploaded files",
      "delete_package": "Delete any package",
      "edit_package": "Edit any package",
      "manage_permissions": "Change roles and permissions",
      "admin_panel_access": "Open the admin panel",
      "view_system_health": "See server health",
      "view_users_info": "See user details and stats",
      "ban_users": "Ban and unban",
      "mute_player": "Mute and unmute in chat",
      "manage_games": "Moderate games (remove, pause, close)",
      "view_system_logs": "Read server logs",
      "manage_storage": "Change storage limits"
    },
    "savePermissions": "Save",
    "editRole": "Role…",
    "gameSearch": "Search games by title",
    "noGames": "No games right now.",
    "gameFinished": "Finished",
    "gamePaused": "Paused",
    "playersCount": "{{count}}/{{max}} players",
    "manage": "Manage",
    "gameGone": "This game has ended or was closed.",
    "packageName": "Package: {{title}}",
    "nobodyInGame": "Nobody is in this game.",
    "people": "People in this game",
    "resume": "Resume",
    "pause": "Pause",
    "openGame": "Open game",
    "closeGame": "Close game",
    "confirmCloseGame": "Confirm: close for everyone",
    "closeGameHelp": "Everyone in the game is sent back to the home page and the game is deleted.",
    "offline": "Left or offline",
    "remove": "Remove",
    "confirmRemove": "Confirm remove",
    "removeNamed": "Remove {{name}}",
    "noPackages": "No packages match.",
    "byAuthor": "by {{name}}",
    "packageSize": "{{rounds}} rounds, {{questions}} questions",
    "edit": "Edit",
    "deleteNamed": "Delete {{name}}",
    "storage": "Storage"
  },
  "myPackages": {
    "title": "My packages",
    "guest": "Guest accounts can't own packages. Sign in with Discord to publish and manage your own.",
    "empty": "You haven't published a package yet. Create one in the editor or upload a .siq or .oq file.",
    "published": "published {{when}}",
    "host": "Host",
    "edit": "Edit",
    "opening": "Opening…",
    "delete": "Delete",
    "confirmDelete": "Yes, delete it",
    "deleteHelp": "Deleting removes the package for everyone. Games already running keep their copy.",
    "deleteFailed": "Couldn't delete this package. Try again.",
    "openFailed": "Couldn't open this package in the editor. Try again.",
    "link": "My packages"
  },
  "storage": {
    "loadFailed": "Could not load storage usage.",
    "title": "Storage",
    "used": "{{used}} of {{quota}} used",
    "usedNoLimit": "{{used}} used, no limit",
    "almostFull": "You're close to your limit. Turn on media compression or delete packages you no longer need.",
    "full": "You've reached your limit. Delete packages you no longer need or ask an admin for more space.",
    "bucket": "Whole storage",
    "bucketFiles_one": "{{count}} stored file",
    "bucketFiles_other": "{{count}} stored files",
    "groupsTitle": "Limits by group",
    "groupsHelp": "In megabytes; leave a field empty for no limit. A file shared by several people counts for each of them, while storage keeps one copy.",
    "usersTitle": "Who uses the most",
    "noUsers": "Nobody has stored anything yet.",
    "noLimit": "No limit",
    "save": "Save",
    "saved": "Saved",
    "ownQuota": "Own limit",
    "ownQuotaLabel": "Storage limit for {{name}}",
    "groupDefault": "Group limit",
    "groups": {
      "guest": "Guests",
      "user": "Players",
      "moderator": "Moderators",
      "admin": "Admins"
    },
    "fields": {
      "userQuotaBytes": "Total per person",
      "packageBytes": "One package",
      "imageBytes": "One picture",
      "audioBytes": "One sound file",
      "videoBytes": "One video"
    },
    "projected": "This package: approximately +{{size}}.",
    "projectedOverQuota": "This package may need {{size}} more space and exceed your limit. The actual upload will check available storage.",
    "projectedUsage": "{{used}} already used; this package may add {{pending}}."
  },
  "allPlay": {
    "kickerStake": "Stake for everyone",
    "kickerNoRisk": "No risk for everyone",
    "ruleStake": "Everyone stakes and writes an answer. Right wins your stake, wrong loses it. Stakes up to {{max}}.",
    "ruleNoRisk": "Everyone writes an answer. Right wins {{points}}, wrong costs nothing.",
    "stakePrompt": "Make your stake — nobody sees it until the answers are in",
    "players": "Players"
  },
  "point": {
    "pick": "Click where the answer is",
    "picture": "Question picture",
    "pictureWaiting": "Wait for the target picture to appear.",
    "pictureUnavailable": "The target picture is unavailable. Ask the showman to skip.",
    "prompt": "Click the spot on the picture",
    "cursor": "Cursor at {{x}}% from the left, {{y}}% from the top. Arrow keys move it, Enter picks.",
    "pickedDescription": "Your selected point: {{x}}% of the image width from the left, {{y}}% of its height from the top.",
    "answerDescription": "{{name}} selected {{x}}% of the image width from the left, {{y}}% of its height from the top.",
    "finalPictureUnavailable": "The target picture is unavailable. You cannot submit a point answer.",
    "targetDescription": "Correct point: {{x}}% of the image width from the left, {{y}}% of its height from the top. Tolerance radius: {{radius}}% of the image width.",
    "imageDimensions": "Image dimensions: {{width}} by {{height}} pixels.",
    "imageDimensionsUnavailable": "Image dimensions are not yet available."
  },
  "stats": {
    "title": "Your games",
    "seeLeaderboard": "See the leaderboard",
    "loadFailed": "Couldn't load your stats.",
    "noGames": "Finish a game as a player and your results show up here.",
    "games": "Games",
    "wins": "Wins",
    "totalScore": "Total score",
    "bestScore": "Best game",
    "accuracy": "Right answers",
    "answers": "{{right}} right and {{wrong}} wrong answers in all.",
    "recent": "Latest games",
    "won": "Won",
    "place": "Place {{place}} of {{players}}",
    "played": "Played"
  },
  "leaderboard": {
    "title": "Leaderboard",
    "help": "Players ranked by games won, then by total score. Guest accounts aren't listed.",
    "period": "Period",
    "periods": {
      "week": "This week",
      "month": "This month",
      "all": "All time"
    },
    "loadFailed": "Couldn't load the leaderboard.",
    "empty": "Nobody has finished a game in this period yet.",
    "player": "Player",
    "you": "you"
  },
  "report": {
    "open": "Something wrong with this question?",
    "title": "Report this question",
    "help": "The package's author sees your note and can fix the question.",
    "reason": "What's wrong?",
    "reasons": {
      "wrong_answer": "The answer is wrong",
      "broken_media": "A picture, sound or video doesn't work",
      "offensive": "It's offensive",
      "other": "Something else"
    },
    "comment": "Details (optional)",
    "commentPlaceholder": "For example, the right answer and a source",
    "send": "Send report",
    "sent": "Thanks, the author will see your report.",
    "already": "You already reported this question.",
    "failed": "Couldn't send the report. Try again."
  },
  "reports": {
    "short": "Reports",
    "button": "Reports, {{n}} open",
    "title": "Reports on {{title}}",
    "help": "What players flagged during games. Fix the question in the editor, then mark the report resolved.",
    "noText": "A question without text",
    "resolve": "Mark resolved",
    "reopen": "Open again"
  },
  "resume": {
    "title": "Finish the upload",
    "notYours": "Only the package's author can finish its upload.",
    "notFound": "This package doesn't exist any more.",
    "done": "All media is uploaded",
    "doneHelp_one": "Its {{count}} media file is in storage, so the package is ready to play.",
    "doneHelp_other": "All {{count}} media files are in storage, so the package is ready to play.",
    "notInFile_one": "{{count}} missing file isn't in the file you picked. Pick the file this package was uploaded from.",
    "notInFile_other": "{{count}} missing files aren't in the file you picked. Pick the file this package was uploaded from.",
    "otherPackage": "You picked “{{picked}}”, but this is “{{title}}”. Pick the file this package was uploaded from.",
    "stashAll_one": "This browser still has the missing file from the first try.",
    "stashAll_other": "This browser still has all {{count}} missing files from the first try.",
    "stashSome": "This browser still has {{count}} of the {{total}} missing files from the first try. Upload them now, then pick the package file for the rest.",
    "uploadStashed_one": "Upload {{count}} file",
    "uploadStashed_other": "Upload {{count}} files",
    "pickHelp": "Pick the same .siq or .oq file again. Only the media that's missing is uploaded."
  },
  "roundTransition": {
    "title": "Next round",
    "description": "Round {{n}} — {{name}}",
    "firstTitle": "First round"
  },
  "skipRound": {
    "title": "Skip to the next round?",
    "help_one": "{{count}} question is still on the board. It won't be played.",
    "help_other": "{{count}} questions are still on the board. They won't be played.",
    "helpEmpty": "The next round starts right away.",
    "confirm": "Skip round"
  },
  "discordActivity": {
    "connecting": "Connecting to Discord…",
    "findingGame": "Looking for this call's game…",
    "retry": "Try again",
    "pickTitle": "Pick a package for this call",
    "pickHint": "Whoever picks first hosts the game. Everyone else in the call joins it automatically.",
    "search": "Search packages",
    "noPackages": "No packages found.",
    "gameReady": "{{host}} is hosting this call's game.",
    "joinGame": "Join the game",
    "errors": {
      "not_configured": "This server isn't set up to run as a Discord Activity.",
      "auth_failed": "Couldn't sign in with Discord at this step: {{step}}",
      "timeout": "Discord didn't answer at this step: {{step}}",
      "settings": "Couldn't reach the OpenQuester server."
    },
    "steps": {
      "handshake": "Connecting to Discord…",
      "authorize": "Waiting for Discord permission…",
      "sign_in": "Signing in to OpenQuester…",
      "authenticate": "Finishing Discord sign-in…"
    },
    "rejoinGame": "Back to the game",
    "otherGames": "Other games",
    "gameCode": "Game code or link",
    "joinByCode": "Join",
    "noOtherGames": "No other open games right now.",
    "presence": {
      "lobby": "In the lobby",
      "paused": "Paused",
      "round": "{{round}}",
      "finished": "Game over",
      "lobbyDetails": "OpenQuester quiz",
      "choosing": "Choosing a game"
    }
  },
  "mediaEditor": {
    "title": "Edit media",
    "edit": "Edit",
    "loading": "Preparing media…",
    "queue": "File {{index}} of {{total}}",
    "cancelProcessing": "Cancel processing",
    "processing": "Processing media…",
    "retry": "Retry",
    "discardPrompt": "Discard this media edit?",
    "skip": "Skip file",
    "remaining": "Add remaining unchanged",
    "unchanged": "Use unchanged",
    "save": "Save media",
    "saveQuestion": "Save question",
    "saveDetails": "Save package details",
    "saveNext": "Save and next",
    "imageTools": "Image tools",
    "select": "Select / move",
    "pen": "Pen",
    "arrow": "Arrow",
    "rectangle": "Rectangle",
    "text": "Text",
    "blur": "Blur area",
    "undo": "Undo media change",
    "redo": "Redo",
    "canvas": "Image preview. Use the toolbar to draw; select an annotation to move it with arrow keys.",
    "fit": "Fit to preview",
    "compare": "Hold to see original",
    "updating": "Updating final preview…",
    "rotateLeft": "Rotate left",
    "rotateRight": "Rotate right",
    "wholeBlur": "Whole-image blur",
    "quality": "Output quality",
    "small": "Small file",
    "balanced": "Balanced",
    "high": "High quality",
    "color": "Drawing color",
    "textSize": "Text size",
    "strength": "Blur strength",
    "stroke": "Stroke width",
    "annotation": "Selected annotation",
    "delete": "Delete annotation",
    "waveform": "Audio waveform",
    "start": "Start",
    "end": "End",
    "position": "Playback position",
    "pause": "Pause preview",
    "duration": "Result: {{duration}}",
    "removeAudio": "Remove audio",
    "noAudio": "This video has no audio",
    "fadeIn": "Fade in",
    "fadeOut": "Fade out",
    "fadeInSeconds": "Fade-in duration in seconds",
    "fadeOutSeconds": "Fade-out duration in seconds",
    "visualUnavailable": "Timeline preview is unavailable. You can still use the time controls.",
    "choiceImage": "Option {{letter}} image",
    "logo": "Package image",
    "errors": {
      "mediaSize": "This file exceeds the 100 MB editor limit.",
      "mediaType": "Choose an image, audio, or video file supported by this field.",
      "unsupported": "This browser cannot process the selected tracks. Try desktop Chrome or Edge, or use the file unchanged.",
      "unsupportedImage": "This image or browser cannot be edited here. Animated images and SVG are kept unchanged.",
      "blurUnsupported": "Blur is unavailable in this browser.",
      "downloadFailed": "The original file couldn't be downloaded from storage. Check your connection and retry; the attachment is unchanged.",
      "downloadCorrupt": "The downloaded file doesn't match the one in this package. Retry; the attachment is unchanged.",
      "processingFailed": "Media processing failed. Your changes are still here; retry or use the file unchanged.",
      "trim": "Choose a start before the end within this file. Use minutes:seconds (for example, 01:23.50)."
    },
    "zoom": "Preview zoom",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "actualSize": "Show at 100%",
    "crop": "Crop",
    "cropHelp": "Drag over the image to choose what to keep, then apply. Values below are percentages of the original image.",
    "cropx": "Left (%)",
    "cropy": "Top (%)",
    "cropwidth": "Width (%)",
    "cropheight": "Height (%)",
    "applyCrop": "Apply crop",
    "resetCrop": "Reset crop",
    "trimTitle": "Keep a fragment",
    "trimHelp": "Choose a point on the timeline, then trim to its left or right. Fine-tune the times below.",
    "startTime": "Start time (min:sec)",
    "endTime": "End time (min:sec)",
    "secondsUnit": "s",
    "fadeHelp": "A fade can fill the fragment. Increasing one shortens the other if needed.",
    "play": "Play preview",
    "playbackTools": "Playback and trimming",
    "trimLeft": "Trim everything left of the playhead",
    "trimRight": "Trim everything right of the playhead",
    "timelineHelp": "Click or drag on the timeline to seek. Arrow keys move the playhead; Space plays or pauses.",
    "rotation": "Rotation (degrees)",
    "restoreAudio": "Restore audio",
    "fadeEnvelope": "Volume fade envelope"
  }
}
